import _trim from 'lodash/trim';
import EmployeeReader from '../readers/Employee';
export var getEmployeeDisplayName = function getEmployeeDisplayName(emp) {
  var displayName = EmployeeReader.displayName(emp);
  if (displayName) return displayName;
  var firstName = EmployeeReader.firstName(emp) || '';
  var lastName = EmployeeReader.lastName(emp) || '';
  return _trim("".concat(firstName, " ").concat(lastName));
};